import React, { Component } from "react";
import { Upload, message, Icon, Select } from "antd";
import custom from "../config/custom";
import _ from "lodash";
import { request } from "../utils/http";
import { get } from "../utils/sockets";
import { getAttribute } from "../utils/models";
import FormItem from "./FormItem";

class File extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: true,
      uploading: false,
      name: "files",
      ids: [],
      defaultFileList: [],
      count: 0,
      listType: props.listType || "picture-card",
      multiple: props.multiple || false,
      action: this.getAction(props),
      withCredentials: true,
      accept: props.accept || "image/*",
      onPreview: this.onPreview,
      maxCount: props.maxCount || Infinity
    };
  }

  getAction(props) {
    if (props.model === "dispatch" && props.id && props.attribute === "files") {
      return `${custom.baseUrl}/files/dispatch/${props.id}`;
    }

    return `${custom.baseUrl}/files`;
  }

  componentWillMount() {
    if (this.props.id) {
      this.setState({ fetching: true });

      get(`/${this.props.model}/${this.props.id}/${this.props.attribute}`)
        .then(response => {
          this.setState({
            ids: _.map(response, "id"),
            defaultFileList: _.map(response, this.fileAdapter),
            count: response.length
          });
        })
        .catch(() => {
          //
        })
        .then(() => {
          this.setState({ fetching: false });
        });
    } else {
      this.setState({ fetching: false });
    }
  }

  onPreview(file) {
    let id = file.uid;

    if (file.response) {
      const firstFile = _.first(file.response.fileList);

      if (firstFile && firstFile.name) {
        id = firstFile.id;
      }
    }

    if (id) {
      window.open(`${custom.baseUrl}/files/${id}?download`);
    }
  }

  save() {
    const value = this.props.form.getFieldValue(this.props.attribute);

    request(`${custom.baseUrl}/${this.props.model}/${this.props.id}`, {
      method: "PATCH",
      data: { [this.props.attribute]: value }
    })
      .then(() => {
        //
      })
      .catch(() => {
        //
      });
  }

  onChange(info) {
    if (info.file.status === "uploading") {
      this.setState({ uploading: true });
    } else if (info.file.status === "done") {
      const ids = _.map(info.file.response.fileList, "id");

      this.setState({
        uploading: false,
        ids: [...this.state.ids, ...ids],
        count: this.state.count + 1
      });

      if (this.props.autoSave && this.props.id) {
        this.save();
      }

      message.success("File uploaded successfully");
    } else if (info.file.status === "error") {
      this.setState({ uploading: false });
      message.error("File upload failed");
    }
  }

  onRemove(info) {
    let id = info.uid;

    if (info.response) {
      const firstFile = _.first(info.response.fileList);

      id = firstFile && firstFile.hasOwnProperty("id") ? firstFile.id : id;
    }

    this.setState({
      count: this.state.count - 1,
      ids: _.without(this.state.ids, id)
    });

    request(`${custom.baseUrl}/files/${id}`, {
      method: "DELETE"
    })
      .then(() => {})
      .catch(() => {
        this.setState({ count: this.state.count + 1 });
      });
  }

  fileAdapter(file) {
    return {
      uid: file.id,
      name: file.originalName,
      status: "done",
      url: `${custom.baseUrl}/files/${file.id}`,
      thumbnailUrl: `${custom.baseUrl}/files/${file.id}`
    };
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const attribute = getAttribute(this.props.model, this.props.attribute);
    const limit = attribute.hasOwnProperty("limit")
      ? attribute.limit
      : this.state.maxCount;
    const uploadButton = (
      <div>
        <Icon type={this.state.uploading ? "loading" : "plus"} />
        <div>Upload</div>
      </div>
    );
    return (
      <FormItem {...this.props}>
        {getFieldDecorator(this.props.attribute, {
          initialValue: this.state.ids
        })(<Select style={{ display: "none" }} mode={"multiple"} />)}
        {!this.state.fetching && (
          <Upload
            {...this.state}
            disabled={this.props.fetching || this.props.disabled}
            onChange={info => {
              this.onChange(info);
            }}
            onRemove={info => {
              this.onRemove(info);
            }}
          >
            {this.state.count < limit && uploadButton}
          </Upload>
        )}
      </FormItem>
    );
  }
}

export default File;



// WEBPACK FOOTER //
// ./src/inputs/File.js